// extracted by mini-css-extract-plugin
var _1 = "SelectButton-moduletext__Unpo6";
export { _1 as "text" }
